import { MetricCard } from "@/components/common/metric-card";
import { DashboardSnapController } from "@/components/landing/dashboard-snap-controller";
import { LandingHero } from "@/components/landing/landing-hero";
import { SiteShell } from "@/components/layout/site-shell";
import { SiteNav } from "@/components/layout/site-nav";
import { MapCanvasBasic } from "@/components/map/map-canvas-basic";
import { ActorGraphPreview } from "@/components/region/actor-graph-preview";
import { EventList } from "@/components/region/event-list";
import { RegionHeader } from "@/components/region/region-header";
import { RegionMiniMap } from "@/components/region/region-mini-map";
import { TimelineRibbon } from "@/components/region/timeline-ribbon";
import { anarchyRepository } from "@/repositories/anarchy-repository";
import { siteConfigRepository } from "@/repositories/site-config-repository";

export default function Home() {
  const siteConfig = siteConfigRepository.getSiteConfig();
  const regions = anarchyRepository.getRegions();
  const pressurePoints = anarchyRepository.getPressurePoints();
  const activeRegion = regions[0];
  if (!activeRegion) {
    throw new Error("The validated anarchy dataset does not contain an active region");
  }
  const activeEvents = anarchyRepository.getEvents(activeRegion.id);
  const actorGraph = anarchyRepository.getActorGraph(activeRegion.id);
  if (!actorGraph) {
    throw new Error(`The active region "${activeRegion.id}" does not have an actor graph`);
  }

  const dashboard = (
    <SiteShell
      map={<MapCanvasBasic regions={regions} pressurePoints={pressurePoints} />}
      sidebar={
        <div className="space-y-4">
          <RegionHeader region={activeRegion} />
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-1">
            {activeRegion.metrics.map((metric) => (
              <MetricCard key={metric.id} metric={metric} />
            ))}
          </div>
          <RegionMiniMap region={activeRegion} />
          <TimelineRibbon region={activeRegion} />
          <ActorGraphPreview graph={actorGraph} />
          <EventList events={activeEvents} />
        </div>
      }
      // lower={
      //   <div className="mx-auto grid max-w-7xl gap-4">
      //     <div id="leaders">
      //       <LeaderGrid leaders={leaders} />
      //     </div>
      //     <div id="themes" className="grid gap-4 xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      //       <ConstellationGraph constellation={constellation} />
      //       <ThemeEventList events={events} constellation={constellation} />
      //     </div>
      //   </div>
      // }
    />
  );

  return (
    <>
      <SiteNav brand={siteConfig.brand} items={siteConfig.navigation} developerItems={siteConfig.developerNavigation} />
      <DashboardSnapController
        config={siteConfig.landing}
        landing={<LandingHero config={siteConfig.landing} />}
        dashboard={dashboard}
      />
    </>
  );
}
